/**
 * Initializes pause/play controls for one Power Visual block.
 *
 * @param {HTMLElement} block Power Visual block element.
 */
const initVideoControls = ( block ) => {

	const pauseButton = block.querySelector( '.b-power-visual__pause-button' );
	const iframe = block.querySelector( '.b-power-visual__bg-video iframe' );

	if ( ! pauseButton || ! iframe || pauseButton.dataset.videoControlsInit === 'true' ) {

		return;

	}

	let isPaused = false;

	/**
	 * Sends a command to the YouTube iframe player.
	 *
	 * @param {string} command Player command name.
	 */
	const sendYouTubeCommand = ( command ) => {

		iframe.contentWindow?.postMessage(
			JSON.stringify( {
				event: 'command',
				func: command,
				args: [],
			} ),
			'*'
		);

	};

	pauseButton.addEventListener( 'click', () => {

		if ( isPaused ) {

			sendYouTubeCommand( 'playVideo' );
			pauseButton.classList.remove( 'is-paused' );

		} else {

			sendYouTubeCommand( 'pauseVideo' );
			pauseButton.classList.add( 'is-paused' );

		}
		isPaused = !isPaused;

	} );

	pauseButton.dataset.videoControlsInit = 'true';

};

/**
 * Injects deferred video template into background wrapper.
 *
 * @param {HTMLElement} block Power Visual block element.
 */
const loadDeferredVideo = ( block ) => {

	const bgWrapper = block.querySelector( '.b-power-visual__bg-video' );
	const videoTemplate = block.querySelector( '.js-video-play-component-template' );

	if ( ! bgWrapper || ! videoTemplate ) {

		return;

	}

	const templateContent = videoTemplate.content.cloneNode( true );

	bgWrapper.innerText = '';
	bgWrapper.appendChild( templateContent );

};

document.querySelectorAll( '.b-power-visual' ).forEach( ( block ) => {

	const hasDeferredVideo = Boolean( block.querySelector( '.js-video-play-component-template' ) );

	if ( ! hasDeferredVideo ) {

		initVideoControls( block );
		return;

	}

	if ( 'IntersectionObserver' in window ) {

		const observer = new IntersectionObserver( ( entries, currentObserver ) => {

			entries.forEach( ( entry ) => {

				if ( ! entry.isIntersecting ) {

					return;

				}

				loadDeferredVideo( block );
				initVideoControls( block );
				currentObserver.unobserve( entry.target );

			} );

		}, {
			root: null,
			rootMargin: '200px 0px',
			threshold: 0.01,
		} );

		observer.observe( block );
		return;

	}

	loadDeferredVideo( block );
	initVideoControls( block );

} );
